import { render, staticRenderFns } from "./Greets.vue?vue&type=template&id=960953f8&scoped=true&"
import script from "./Greets.vue?vue&type=script&lang=js&"
export * from "./Greets.vue?vue&type=script&lang=js&"
import style0 from "./Greets.vue?vue&type=style&index=0&id=960953f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960953f8",
  null
  
)

export default component.exports